import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

function LoadingViewerFragment() {
  return <FixaSkeleton width="100%" height="44px" />;
}

export default LoadingViewerFragment;
